// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__27r-s","kpiContainer":"home_kpiContainer__5IgzO","blockContainer":"home_blockContainer__QH4AF","transactionContainer":"home_transactionContainer__1WOA0"};